import React from 'react'
import './ActiveStrategies.css'

const strategies = [
	{
		name: 'Aave',
		type: 'Lending',
		status: 'active',
		asset: 'USDC',
		apy: '8.2%',
		color: '#9B5DE5',
		symbol: 'Aa',
	},
	{
		name: 'Compound',
		type: 'Lending',
		status: 'active',
		asset: 'ETH',
		apy: '4.5%',
		color: '#00BB7E',
		symbol: 'Co',
	},
	{
		name: 'Curve',
		type: 'Liquidity',
		status: 'active',
		asset: 'USDC/USDT',
		apy: '12.4%',
		color: '#4D8BFF',
		symbol: 'Cu',
	},
]

export const ActiveStrategies = () => {
	return (
		<div className="strategies-wrapper">
			<h2>Active Strategies</h2>
			<div className="strategies-container">
				{strategies.map((strategy, index) => (
					<div className="strategy-card" key={index}>
						<div className="card-header">
							<div
								className="icon-circle"
								style={{ backgroundColor: strategy.color }}
							>
								{strategy.symbol}
							</div>
							<div className="card-info">
								<h3>{strategy.name}</h3>
								<span className="type">{strategy.type}</span>
							</div>
							<span className="status-badge">
								{strategy.status}
							</span>
						</div>

						<div className="card-body">
							<div className="row">
								<span className="label">Asset</span>
								<span className="value">{strategy.asset}</span>
							</div>
							<div className="row">
								<span className="label">
									APY <span className="info-icon">ℹ️</span>
								</span>
								<span className="value highlight">
									{strategy.apy}
								</span>
							</div>
						</div>

						<button className="view-btn">
							View Details <span className="arrow">↗</span>
						</button>
					</div>
				))}
			</div>
		</div>
	)
}
